import RosterIdentityUpdateContainer from './RosterIdentityUpdateContainer';

export default RosterIdentityUpdateContainer;
